// Async boundary required by Module Federation: it lets the shared packages (react, antd,
// refine ...) be negotiated with the remote app before any of them runs. Keep this file
// tiny and do not import anything else here; the real entry is bootstrap.tsx.
import('./bootstrap');

export {};
